import type React from "react";
import type { InviteGuestInfo } from "~/interface/organization";
import styles from "./index.module.scss";

interface ModalProps {
  guests: InviteGuestInfo[];
  setGuests: React.Dispatch<React.SetStateAction<InviteGuestInfo[]>>;
}

const InviteGuestForm: React.FC<ModalProps> = ({ guests, setGuests }) => {
  const handleEmailChange = (index: number, email: string) => {
    const updateGuests = [...guests];
    if (updateGuests[index]) {
      updateGuests[index]!.email = email;
    }
    setGuests(updateGuests);
  };

  const addGuest = () => {
    setGuests([...guests, { email: "" }]);
  };

  const removeMember = (index: number) => {
    const updatedGuests = [...guests];
    updatedGuests.splice(index, 1);
    setGuests(updatedGuests);
  };

  return (
    <div className={styles["memberList"]}>
      {guests.map((guest, index) => (
        <div key={index} className={styles["memberInputRow"]}>
          <div className={styles["emailField"]}>
            <label>メールアドレス</label>
            <input
              type="email"
              placeholder="メールアドレス"
              value={guest.email}
              onChange={(e) => handleEmailChange(index, e.target.value)}
              required
              data-testid={index === 0 ? "invite-email" : `invite-email-${index}`}
            />
          </div>

          <div className={styles["roleField"]}>
            <label>権限</label>
            <select value={"guest"} disabled>
              <option value="guest">ゲスト</option>
            </select>
          </div>

          {index > 0 && (
            <button
              className={styles["removeButton"]}
              type="button"
              onClick={() => removeMember(index)}
            >
              ー
            </button>
          )}
        </div>
      ))}

      <button
        className={styles["addButton"]}
        type="button"
        onClick={addGuest}
        data-testid="invite-add-row"
      >
        <span>+</span> 追加
      </button>
    </div>
  );
};

export default InviteGuestForm;
